import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCountries } from '../selectors/app'

/**
 *
 * @param value - Country code or country name
 * @returns
 */
export const useCountryInfo = (value?: string) => {
  const countries = useSelector(selectCountries)

  const countryInfo = useMemo(
    () => countries.find((country) => country.name === value || country.value === value),
    [countries, value]
  )

  if (!value) {
    return
  }

  return countryInfo
}
